import { useCallback, useEffect, useState } from "react";
import api from "@/lib/api";
import { engineAccess } from "@/lib/engine";

export const MEMBERSHIP_EVENT = "qc-engine-membership-changed";

// `skip`: no consulta /api/engine/me (vista de soporte del admin, que no es miembro).
export default function useEngine({ skip = false } = {}) {
    const [state, setState] = useState({ loading: !skip, member: false, me: null, access: engineAccess(null) });
    const [attempt, setAttempt] = useState(0);
    useEffect(() => {
        if (skip) return undefined;
        let alive = true;
        api.get("/api/engine/me")
            .then((r) => alive && setState({ loading: false, member: true, me: r.data, access: engineAccess(null) }))
            .catch((e) => alive && setState({ loading: false, member: false, me: null, access: engineAccess(e) }));
        return () => { alive = false; };
    }, [attempt, skip]);
    useEffect(() => {
        const onChange = () => setAttempt((n) => n + 1);
        window.addEventListener(MEMBERSHIP_EVENT, onChange);
        return () => window.removeEventListener(MEMBERSHIP_EVENT, onChange);
    }, []);
    const reload = useCallback(() => {
        setState((s) => ({ ...s, loading: true }));
        // Por evento, no con setAttempt: el menu de AppLayout tiene su propio useEngine y tambien tiene que enterarse.
        window.dispatchEvent(new Event(MEMBERSHIP_EVENT));
    }, []);
    return { ...state, reload };
}
